import { FC } from "react"

const Dashboard: FC = () => {
  return (
    <>
    </>
  )
}

export default Dashboard
